import image1 from './Images/image-1.webp';

const staticData = [
    {
        id: '1',
        title: 'Pre Congress INAACC 2024',
        image: image1,
        videoId: 'cde7ebd440f855f13da04ec983bb43c1',
    },
];

export default staticData;
